import React, { useEffect, useState, useCallback } from "react";
import { Grid, Box, Button } from "@mui/material";
import { useDispatchWrapper } from "../../hooks";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
} from "../../redux/messages/messagesActions";
import { ManageQuickReplyTemplateRightPanel } from "./ManageQuickReplyTemplateRightPanel";
// import { useBillingCompanyContext } from "../../providers";
import { useDebounce } from "../../hooks/useDebounce";
import { PageLoader } from "../../components/PageLoader/PageLoader";
import { LoadState } from "../../constants/enums";
import { ViewToggle } from "../../components/ViewToggle";
// import { useReduxStore } from "../../redux/store.hooks";
import { ControlledCustomSelect } from "../../components/formsComponents";
import { StandadCard } from "../../components/Cards";
import { Breadcrumb } from "../../layout/fullLayout/breadcrumb/Breadcrumb";
import { IBreadcrumbProps } from "../../layout/fullLayout/breadcrumb/IBreadcrumbProps";
import { fetchQuickReplyTemplateListAsync } from "../../redux/quickReplyTemplates/quickReplyTemplateAction";
import { IQuickReplyTemplateData } from "../../redux/quickReplyTemplates/quickReplyTemplate.types";
import { INITIAL_QUICK_REPLY_TEMPLATE_DATA } from "../../redux/quickReplyTemplates/defaultState";
import { QuickReplyTemplatesAutoSearch } from "../../components/AutoCompleteSearches/QuickReplyTemplatesAutoSearch";
import { QuickTemplateTable } from "./components/QuickTemplateTable";
import { QuickReplyTemplateCardsV2 } from "./components/QuickReplyTemplateCardsV2";
import { stripHtml } from "../../helpers/stripHtml";
import { useWhatsAppStatus } from "../../contexts/WhatsAppStatusProvider";
import {
  VIEWS_CACHING_KEYS,
} from "../../constants/constants";
import { useDataTableV2Context } from "../../components/TableV2/context/DataTableV2Provider";
import { IStoreState } from "../../redux/initialStoreState";
import { useSelector } from "react-redux";

// 🔹 Utility: normalize meta template into consistent shape
const normalizeTemplate = (template: any): IQuickReplyTemplateData => {
  const components = template.components || [];
  return {
    ...template,
    header: components.find((c: any) => c.type === "HEADER") || {
      type: "HEADER",
      text: "",
      format: null,
    },
    body: components.find((c: any) => c.type === "BODY") || {
      type: "BODY",
      text: "",
    },
    footer: components.find((c: any) => c.type === "FOOTER") || {
      type: "FOOTER",
      text: "",
    },
    buttons: components.find((c: any) => c.type === "BUTTONS") || {
      type: "BUTTONS",
      buttons: [],
    },
  };
};

interface IQuickReplyTemplateListV2Props {
  onTemplateDetails?: (template: IQuickReplyTemplateData) => void;
  selectedTemplateUuid?: string | null;
  showCreateButton?: boolean;
  searchTemplateName?: string;
  onSearchChange?: (searchName: string) => void;
  toNumber?: string;
  isFromChat?: boolean;
  onClose?: () => void;
  onCreateClick?: () => void;
  hideCreateButton?: boolean;
  compactCardsView?: boolean;
  refetchRef?: React.MutableRefObject<(() => void) | null>;
  onSelectTemplate?: (message: string) => void;
}

export const QuickReplyTemplateListV2: React.FC<
  IQuickReplyTemplateListV2Props
> = (props) => {
  const { saveDataInCache, cachingDataState, getCachedDataByKey } =
    useDataTableV2Context();

  const {
    onTemplateDetails,
    selectedTemplateUuid = null,
    showCreateButton = true,
    searchTemplateName: externalSearchName,
    onSearchChange,
    toNumber,
    isFromChat = false,
    onClose,
    onCreateClick,
    hideCreateButton = false,
    compactCardsView = false,
    refetchRef,
    onSelectTemplate,
  } = props;

  const BCrumb: IBreadcrumbProps["items"] = [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      to: "/quick-reply-templates",
      title: "Quick Reply Templates",
    },
  ];

  const dispatch = useDispatchWrapper();
  // const { comapny } = useBillingCompanyContext() || {};
  const { useMetaService } = useWhatsAppStatus();
  // const company_outlet_uuid = comapny?.company_outlet_uuid;

  const { list: quickReplyTemplateList, loading: dataLoading } =
    useSelector((state: IStoreState) => state.quickReplyTemplate.list);
  const { totalRecords: storeTotalRecords } =
    useSelector((state: IStoreState) => state.quickReplyTemplate.list);

  const [channels, setChannels] = useState<IQuickReplyTemplateData[]>([]);
  const [openManageWhatsAppTemplatePanel, setOpenManageWhatsAppTemplatePanel] =
    useState<IQuickReplyTemplateData | null>(null);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [internalSearchName, setInternalSearchName] = useState("");
  const [status, setStatus] = React.useState("ACTIVE");
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [showCardsView, setShowCardsView] = useState(true);

  const searchTemplateName =
    externalSearchName !== undefined ? externalSearchName : internalSearchName;

  const debouncedSearchName = useDebounce(searchTemplateName, 500);

  const getChannels = useCallback(
    async (
      channelType: string,
      showLoader?: boolean,
      direction?: "next" | "prev",
      newRowsPerPage?: number
    ) => {
      try {
        if (showLoader) dispatch(saveLoaderProgress());
        // setChannels([]);

        if (channelType === "WHATSAPP") {
          let page = currentPage;
          if (direction === "next") page++;
          else if (direction === "prev") page = Math.max(1, page - 1);
          else page = 1;
          setCurrentPage(page);

          await dispatch(
            fetchQuickReplyTemplateListAsync(
              page,
              // rowsInPerPage
              newRowsPerPage || rowsPerPage,
              // limit
              rowsPerPage,
              // status
              status,
              // date
              { fromDate: "", toDate: "" },
              // searchValue (advanced filters)
              [],
              // company_outlet_uuid
              // company_outlet_uuid,
              // searchByName
              debouncedSearchName,
              // searchByTemplateId
              undefined,
              //template_for
              "QUICK_REPLY"
            )
          );
        }
      } finally {
        dispatch(saveLoaderCompleted());
      }
    },
    [
      // company_outlet_uuid,
      debouncedSearchName,
      currentPage,
      rowsPerPage,
      status,
      dispatch,
    ]
  );

  const handleWhatsappMessageSend = (
    template: IQuickReplyTemplateData,
    toNumber?: string
  ) => {
    // If onSelectTemplate is provided, populate the input field instead of sending
    if (onSelectTemplate) {
      const message = stripHtml(template.text || "");
      onSelectTemplate(message);
      onClose?.();
      return;
    }

    // if (!toNumber) {
    //   dispatch(
    //     showMessage({
    //       type: "error",
    //       message: "Please provide a phone number to send the message",
    //       displayAs: "snackbar",
    //     })
    //   );
    //   return;
    // }

    // // For simple text messages - strip HTML tags
    // const messagePayload = {
    //   fromNumber: null,
    //   toNumber: toNumber,
    //   is_automatic_message: 0,
    //   message: stripHtmlTags(template.text || ""),
    //   whatsapp_web_service: useMetaService ? false : true,
    //   company_outlet_name: comapny?.company_outlet_name,
    //   company_outlet_uuid: comapny?.company_outlet_uuid,
    // };

    // dispatch(
    //   upsertWhatsAppMessage(messagePayload, (isSucess) => {
    //     if (isSucess) {
    //       dispatch(
    //         showMessage({
    //           type: "success",
    //           message: "Message sent successfully",
    //           displayAs: "snackbar",
    //         })
    //       );
    //       onClose?.();
    //     } else {
    //       dispatch(
    //         showMessage({
    //           type: "error",
    //           message: "Failed to send message",
    //           displayAs: "snackbar",
    //         })
    //       );
    //       onClose?.();
    //     }
    //   })
    // );
  };

  const handleSearchChange = (template: any, inputValue: string) => {
    const newSearchName = inputValue || template?.name || "";

    if (onSearchChange) {
      onSearchChange(newSearchName);
    } else {
      setInternalSearchName(newSearchName);
    }
  };

  const handleCreate = () => {
    setOpenManageWhatsAppTemplatePanel(INITIAL_QUICK_REPLY_TEMPLATE_DATA);
  };

  const handleShowCard = (value: boolean) => () => {
    saveDataInCache(VIEWS_CACHING_KEYS.QUICK_REPLY_TEMPLATE_GRID_TABLE_KEY, {
      showCard: value,
    });
    setShowCardsView(value);
  };

  useEffect(() => {
    setChannels((quickReplyTemplateList || []).map(normalizeTemplate));
  }, [quickReplyTemplateList]);

  useEffect(() => {
    if (storeTotalRecords !== undefined) {
      setTotalRecords(storeTotalRecords);
    }
  }, [storeTotalRecords]);

  useEffect(() => {
    getChannels("WHATSAPP");
  }, [debouncedSearchName, status]);

  useEffect(() => {
    const data = getCachedDataByKey(
      VIEWS_CACHING_KEYS.QUICK_REPLY_TEMPLATE_GRID_TABLE_KEY
    );
    setShowCardsView(data ? data.showCard : true);
  }, [
    cachingDataState[VIEWS_CACHING_KEYS.QUICK_REPLY_TEMPLATE_GRID_TABLE_KEY],
  ]);

  // Expose refetch function to parent via ref
  useEffect(() => {
    if (refetchRef) {
      refetchRef.current = () => getChannels("WHATSAPP", true);
    }
  }, [refetchRef, getChannels]);

  return (
    <>
      {showCreateButton && (
        <Breadcrumb
          title="View Quick Reply Template"
          items={BCrumb}
          // actionButtonText="Create Quick Reply Template"
          // onActionButtonClick={handleCreate}
        />
      )}

      <StandadCard>
        <PageLoader loading={dataLoading === LoadState.InProgress}>
          <Grid container spacing={5} justifyContent="center">
            <Grid item xs={12}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  sx={{
                    width: 410,
                    fontWeight: "bold",
                    ml: 2,
                    display: "flex",
                    gap: 2,
                    mt: 1,
                  }}
                >
                  <QuickReplyTemplatesAutoSearch
                    label="Search by Template Name"
                    value={searchTemplateName}
                    onSelect={handleSearchChange}
                  />
                  <ControlledCustomSelect
                    label="Status"
                    value={status}
                    options={[
                      { label: "All", value: "" },
                      { label: "Active", value: "ACTIVE" },
                      { label: "Inactive", value: "INACTIVE" },
                    ]}
                    fullWidth
                    onChange={(e) => setStatus(e.target.value as string)}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mr: 2,
                  }}
                >
                  <ViewToggle
                    isGridView={showCardsView}
                    onToggle={handleShowCard(!showCardsView)}
                  />
                  {!showCreateButton && !hideCreateButton && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={onCreateClick || handleCreate}
                    >
                      Create Quick Reply
                    </Button>
                  )}
                </Box>
              </Grid>

              <Box sx={{ width: "100%", p: 2 }}>
                {/* Template List/Cards View */}
                {showCardsView ? (
                  <QuickReplyTemplateCardsV2
                    templates={channels}
                    onTemplateDetails={onTemplateDetails || (() => {})}
                    selectedTemplate={selectedTemplateUuid}
                    onWhatsappMessageSend={(template) => {
                      handleWhatsappMessageSend(template, toNumber);
                    }}
                    toNumber={toNumber}
                    currentPage={currentPage}
                    totalRecords={totalRecords}
                    onPageChange={(dir, _, perPage) =>
                      getChannels("WHATSAPP", true, dir, perPage)
                    }
                    onRowsPerPageChange={setRowsPerPage}
                    rowsPerPage={rowsPerPage}
                    onTemplatePreview={() => () => {}}
                    isFromQuickReply={true}
                    isFromChat={isFromChat}
                    compactView={compactCardsView}
                  />
                ) : (
                  <QuickTemplateTable
                    fetchList={() => getChannels("WHATSAPP", true)}
                    templates={channels}
                    selectedTemplate={selectedTemplateUuid}
                    onWhatsappMessageSend={(template) => {
                      handleWhatsappMessageSend(template, toNumber);
                    }}
                    toNumber={toNumber}
                    currentPage={currentPage}
                    totalRecords={totalRecords}
                    onPageChange={(dir, _, perPage) =>
                      getChannels("WHATSAPP", true, dir, perPage)
                    }
                    onRowsPerPageChange={setRowsPerPage}
                    rowsPerPage={rowsPerPage}
                    onTemplatePreview={() => () => {}}
                    isFromQuickReply={true}
                    isFromChat={isFromChat}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </PageLoader>
      </StandadCard>
      {openManageWhatsAppTemplatePanel && (
        <ManageQuickReplyTemplateRightPanel
          open
          onClose={() => setOpenManageWhatsAppTemplatePanel(null)}
          onSaveSuccess={() => {
            setOpenManageWhatsAppTemplatePanel(null);
            getChannels("WHATSAPP", true);
          }}
        />
      )}
    </>
  );
};
